import React from "react";
import { GetDayOfWeekName } from "../../../services/helpers.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const DaysOfWeekDropdown = ({
  resources,
  dayOfWeek,
  onDayOfWeekChange,
  containerClass,
  filter,
  id = "dayofweek-dropdown",
  disabled = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["DayOfWeek"]}
      value={dayOfWeek}
      values={[...Array(7).keys()]}
      handleChange={onDayOfWeekChange}
      inputName="dayOfWeek"
      addMarginBottom={false}
      disabled={disabled}
      containerClass={containerClass}
      map={v => ({ key: v, name: GetDayOfWeekName(v, resources) })}
      filter={filter}
    />
  );
};

export default DaysOfWeekDropdown;
